/*eslint no-undef: 0*/
import { fromJS } from 'immutable';
import { toggleActionTypes } from './actions';
import { createReducer } from '../../helpers/store';

const initialState = fromJS({
  isOpen: false
});

export const handleToggleMenu = (state, action) => {
  return state.set('isOpen', action.show);
};

export const toggleReducer = createReducer(initialState, {
  [toggleActionTypes.TOGGLE_MENU]: handleToggleMenu
});



/** WEBPACK FOOTER **
 ** ./src/state/toggle/reducer.js
 **/